import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { deleteReminder, fetchReminders, saveReminders } from "@/api/reminders";
import type { CampaignReminders, SaveReminderEntry } from "@/interfaces/reminders";

export function useReminders(campaignId: string, enabled = true) {
  return useQuery<CampaignReminders>({
    queryKey: ["reminders", campaignId],
    queryFn: () => fetchReminders(campaignId),
    enabled: enabled && !!campaignId,
  });
}

export function useDeleteReminder(campaignId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (reminderNumber: number) => deleteReminder(campaignId, reminderNumber),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["reminders", campaignId] });
      queryClient.invalidateQueries({ queryKey: ["campaigns"] });
    },
  });
}

export function useSaveReminders(campaignId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (entries: SaveReminderEntry[]) => saveReminders(campaignId, entries),
    onSuccess: () => {
      // Re-fetch persisted reminders so the modal shows fresh data next open
      queryClient.invalidateQueries({ queryKey: ["reminders", campaignId] });
      // Refresh campaigns list so reminderDaysLeft in the card updates
      queryClient.invalidateQueries({ queryKey: ["campaigns"] });
    },
  });
}
